import { Box } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useHeader } from 'hooks/useHeader';
import { useBranch } from 'lib/branch/BranchProvider';
import React, { useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router';
import bottomUpScrollTranslateValue from './bottomUpTranslateValue';
import DownloadAppBannerAndQrCode from './DownloadAppBannerAndQrCode';
import DownloadAppQrCode from './DownloadAppQrCode';

const bannerOpacityScrollThreshold = 150;

export interface DownloadAppBannerDesktopProps {
  qrCodeInitialBottomSpacing?: string | string[];
}

const DownloadAppBannerDesktop = ({
  qrCodeInitialBottomSpacing
}: DownloadAppBannerDesktopProps) => {
  const { pathname } = useLocation();

  const [qrCodeTranslateY, setQrCodeTranslateY] = useState(100);
  const [bannerOpacity, setBannerOpacity] = useState(1);
  const { cookieBannerDisplay } = useHeader();
  const [downloadLink, setDownloadLink] = useState('');
  const qrCodeBottomSpacing = cookieBannerDisplay
    ? '138px'
    : qrCodeInitialBottomSpacing ?? '20px';

  const { getBranchQRUrl } = useBranch();

  const isShowQRCode = useMemo(() => {
    if (pathname !== '/') return true;
    return false;
  }, [pathname]);

  useLayoutEffect(() => {
    const onScroll = () => {
      const percentage = bottomUpScrollTranslateValue({
        currentScrollPosition: window.scrollY,
        threshold: 250
      });

      setQrCodeTranslateY(percentage);
      setBannerOpacity(window.scrollY >= bannerOpacityScrollThreshold ? 0 : 1);
    };

    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  useEffect(() => {
    getBranchQRUrl(link => {
      setDownloadLink(link);
    });
  }, [getBranchQRUrl]);

  return (
    <Box>
      <Box
        as={motion.div}
        position="fixed"
        bottom="0px"
        left="50%"
        transform="translateX(-50%)"
        zIndex={bannerOpacity ? 99 : 1}
        paddingBottom="20px"
        initial={{
          opacity: 0
        }}
        animate={{
          opacity: bannerOpacity,
          transitionDelay: bannerOpacity ? '0.2s' : '0s',
          transitionDuration: bannerOpacity ? '0.5s' : '0.2s'
        }}
      >
        {isShowQRCode && (
          <DownloadAppBannerAndQrCode downloadLink={downloadLink} />
        )}
      </Box>

      <Box
        as={motion.div}
        position="fixed"
        bottom="0px"
        right="20px"
        paddingBottom={qrCodeBottomSpacing}
        transition="transform .1s cubic-bezier(.645, .045, .355, 1), padding 0.1s ease"
        willChange="transform"
        initial={{
          translateY: '100%'
        }}
        animate={{
          translateY: `${qrCodeTranslateY}%`
        }}
        zIndex={99}
      >
        <DownloadAppQrCode
          downloadLink={downloadLink}
          bgColor="black"
          padding="10px"
          borderRadius="20px"
        />
      </Box>
    </Box>
  );
};

export default DownloadAppBannerDesktop;
